export default "__VITE_ASSET__COw6apQ3__"